import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectCustomerRatingSettingsById = createBasicSelector(
  selectBase,
  base => base.byId
)
